<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">แจ้งเตือน</h3>
  </div>
  <div class="modal-body">
    <div class="container my-4">
      <div class="my-3 mx-auto text-center">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center">ลำดับ</th>
              <th class="text-center">ชื่อแถว</th>
              <th class="text-left">ค่าปัจจุบัน</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of message;let i = index">
              <td>{{item.index}}</td>
              <td>{{item.columnName}}</td>
              <td>{{item.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-danger" id="cancel" (click)="cancel()">
          <i class="feather icon-x-circle"></i> ปิด
        </button>
      </div>
    </div>
  </div>
</div>
